export enum NtDragHoverType {
    DUPLICATE, MOVE
}
